export const set = (state, action) => {
  return { ...state, variantList: action.payload }
}

// { uuid, item }
export const update = (state, action) => {
  const newList = state.variantList.map((el) => (el.uuid === action.payload.uuid ? action.payload.item : el))
  return { ...state, variantList: newList }
}
